export default "__VITE_ASSET__2fseKRl$__"